import { render, staticRenderFns } from "./ApprTemp1.vue?vue&type=template&id=54aa4c4b&scoped=true&"
import script from "./ApprTemp1.vue?vue&type=script&lang=js&"
export * from "./ApprTemp1.vue?vue&type=script&lang=js&"
import style0 from "./ApprTemp1.vue?vue&type=style&index=0&id=54aa4c4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa4c4b",
  null
  
)

export default component.exports